import { render, staticRenderFns } from "./Template7.vue?vue&type=template&id=bd243146&scoped=true"
import script from "./Template7.vue?vue&type=script&lang=js"
export * from "./Template7.vue?vue&type=script&lang=js"
import style0 from "./Template7.vue?vue&type=style&index=0&id=bd243146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd243146",
  null
  
)

export default component.exports